'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobScrollMessenger', cobScrollMessenger);

	cobScrollMessenger.$inject = ['subjectObserverMessagesService', 'observerService'];

	var subjectObserverMessagesService, observerService;

	function cobScrollMessenger(_subjectObserverMessagesService_, _observerService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			restrict: 'A',
			link: function(scope, element) {

				activate();

				function activate() {
					var threshold = 85;

					//TODO: After new html, watch the scrolling elem not window
					angular.element(element)
						.bind('scroll',
							function() {
								var scrollableHeight = element.prop('scrollHeight');
								var visibleHeight = element.height();
								var hiddenContentHeight = scrollableHeight - visibleHeight;

								if (hiddenContentHeight - element.scrollTop() <= threshold) {
									observerService
										.sendMessageToSubject(scope,
											subjectObserverMessagesService.getSubjectMessages()
												.COB_SUBJECT_SCROLL_MESSAGE);
								}
							});
				}
			}
		};
	}
})();
